import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '"Mi hijo es muy terco, ¿funcionará con él?"',
    a: 'Absolutamente. El protocolo no se basa en "portarse bien", se basa en biología y neurociencia. Es como un detox de azúcar: el cuerpo responde sí o sí.'
  }, {
    q: '"No tengo tiempo para dedicarle horas al día."',
    a: 'Este plan fue hecho por padres y para padres ocupados. Los pasos toman menos de 10 minutos de tu atención.'
  }, {
    q: '"¿Tengo que quitarle el internet para siempre?"',
    a: 'No. El objetivo es el balance. Te enseñaremos cómo usar la tecnología como una herramienta, no como una adicción.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-brand-muted" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <div className="w-16 h-16 bg-brand-navy/5 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-19">
            <HelpCircle className="w-8 h-8 text-brand-navy" data-id="element-20" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-21">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-brand-teal mx-auto rounded-full" data-id="element-22"></div>
        </div>

        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-brand-navy/5 overflow-hidden" data-id="element-24">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-25">
                <span className="text-lg font-bold text-brand-navy pr-8" data-id="element-26">
                  <span className="text-brand-teal mr-2" data-id="element-27">❓</span>
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-navy/50 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-28" />
              </button>

              <AnimatePresence data-id="element-29">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="px-6 pb-6 text-brand-navy/80 leading-relaxed border-t border-brand-navy/5 pt-4" data-id="element-31">
                      <span className="text-green-500 mr-2 font-bold" data-id="element-32">✅</span>
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}